import { isSourceAuthQuery } from '@/components/sourceAuth';

// 获取产品权限
export async function getActiveAuth(gameCode: string) {
  try {
    const res = await Promise.all([
      isSourceAuthQuery({ authSource: 'smart_traffic_user', gameCode }),
      isSourceAuthQuery({ authSource: 'smart_operate_no_auth', gameCode })
    ]);

    const trafficAuth = res[0].data,
      operateNoAuth = res[1].data;
    return { trafficAuth, operateNoAuth, noAuth: operateNoAuth && !trafficAuth };
  } catch (e) {
    console.log(e);
    return { trafficAuth: false, operateNoAuth: true, noAuth: true };
  }
}
